module.exports = __webpack_public_path__ + "img/wa.daf9f407.svg";